export const reportCreditTypes = {
  GET_REPORT_CREDIT: 'GET_REPORT_CREDIT',
  SET_REPORT_CREDIT_FILTERS: 'SET_REPORT_CREDIT_FILTERS',
};